import {BaseControl} from './base-control';

import {SelectControlInterface} from '../../interfaces';
import {SelectOptionInterface} from '../../components';

export class SelectControl extends BaseControl<any> {
    public options: SelectOptionInterface[];
    public multiple: boolean;
    public isDynamic?: boolean;

    constructor(data: SelectControlInterface) {
        super(data);

        this.options = data.options;
        this.multiple = (typeof data.multiple !== 'undefined') ? data.multiple : false;
        this.isDynamic = (typeof data.isDynamic !== 'undefined') ? data.isDynamic : false;
    }
}
